import { Select, Text } from 'grommet';
import { useState } from 'react';

export const CreateSelect = ({ defaultOptions, defaultValue = '', placeholder, id, required, name, onChange, onBlur }: {
  defaultOptions: string[];
  defaultValue?: string;
  placeholder?: string;
  id?: string;
  required?: boolean;
  name?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
}) => {
  const [search, setSearch] = useState('');
  const query = search.trim();
  const matches = defaultOptions.filter((option) => option.toLocaleLowerCase().includes(query.toLocaleLowerCase()));
  const options = matches.map((option) => ({ label: option, value: option, create: false }));
  if (query && !defaultOptions.some((option) => option.trim().toLocaleLowerCase() === query.toLocaleLowerCase())) {
    options.push({ label: `+ Add "${query}" as a new client`, value: query, create: true });
  }
  return <Select id={id} name={name} placeholder={placeholder || 'Select'} required={required}
    value={defaultValue} options={options}
    labelKey={(option) => option.create ? <Text color="#0d48a1" weight={600}>{option.label}</Text> : option.label}
    valueKey={{ key: 'value', reduce: true }}
    dropProps={{ background: 'white', elevation: 'medium', round: '8px', style: { background: 'white' } }}
    onSearch={setSearch} onClose={() => { setSearch(''); onBlur?.(); }}
    onChange={({ option }) => {
      onChange?.(option.create ? query : option.value);
      setSearch('');
    }} />;
};
